import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { stringify } from 'querystring';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-driverprofile',
  templateUrl: './driverprofile.component.html',
  styleUrls: ['./driverprofile.component.css']
})
export class DriverprofileComponent extends BaseCrudComponent {

  	translations:any;
    orders:any;
    drivers:any;
    today:any;
    momentjs: any = moment;

    files:any;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService,
        public mapModal: NgbModal,
      ) {
        super(srv, modalService, storage, router);

        this.read_url = 'LogisticDriver/GetInfo';
        this.create_url = '';
        this.update_url = 'LogisticDriver/UpdateProfile';
        this.delete_url = '';
        this.search_fields = [];
        this.files = [];
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
        });
    }

    getList(){
        var qst = this.read_url;
        
        this.clearData();
        this.loadingList = true;
        this.srv.getCall(qst).subscribe(x => {
            var data = x.data;
            
            this.loadingList = false;
            if(x.status){
                this.u_obj = x.data;
            }
        });
    }

    validateCreateInfo(fields:any){
        let mygroup:any = {};
        mygroup = new FormGroup({
            /*'ClientName': new FormControl(fields.ClientName, [Validators.required]),
            'StatusId': new FormControl(fields.StatusId, [Validators.required])*/
        });
        
        return mygroup.valid;
    }

    public updateItem(form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        /*validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }*/

        var to:any;
        to = {};
        to.id = form.id;
        to.contact = form.contact;
        to.photo = form.photo;

        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if(x.status){
                this.getList();
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else{
                Swal.fire(x.message, '', 'error');
              //this.closeModal(content);
            }
        });
    }

    handleInputChange(e, obj:any) {
        var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
        //console.log(file);
        /*this.files = [];
        this.files.push(file);*/
        //var pattern = /image-*/;
        var reader = new FileReader();

        reader.onload = (_event) => { 
          obj.photo = reader.result;
          //obj.img[0].fname = file.name;
        }

        reader.readAsDataURL(file);
    }
}
